export class GetTrackedQueries {
  public static readonly type = '[Notifications] GetTrackedQueries';
}
